import React from 'react';

import { StatusText } from '../../../components/StatusText/StatusText';
import { BaseStatusTextProps } from '../../../types/BaseStatusTextProps';

export const StatusTextCell = (props: BaseStatusTextProps) => {
  return <StatusText {...props} />;
};
